export default __webpack_public_path__ + "static/cover-video-f6ad208c4b9be2c0dec37d5fbf147a81.mp4";